import React from 'react';
import { Drawer, IconButton, Box, useMediaQuery, useTheme } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface StyledDrawerProps {
  open: boolean;
  onClose: () => void;
  onBack?: () => void;
  children: React.ReactNode;
  width?: number;
  anchor?: 'left' | 'right' | 'top' | 'bottom';
  zIndex?: number; // למשל כשהמגירה נפתחת מתוך דיאלוג (שנמצא מעל המגירה כברירת מחדל)
}

const StyledDrawer: React.FC<StyledDrawerProps> = ({
  open,
  onClose,
  onBack,
  children,
  width = 800,
  anchor = 'left',
  zIndex,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={onClose}
      disableScrollLock
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
      sx={zIndex !== undefined ? { zIndex } : undefined}
      PaperProps={{
        sx: {
          width: isSmallScreen ? '100%' : width, // ✅ ברוחבי מסך קטנים → רוחב מלא
          p: 2,
        
         // position: 'relative',
        },
      }}
    >
      {/* ✅ כפתור BACK בצד שמאל למעלה */}
      <Box sx={{ position: 'relative' }}>
    <IconButton
      onClick={onBack ?? onClose}
      sx={{
        position: 'absolute',
        top: 80,
        [anchor === 'right' ? 'left' : 'left']: 18,
        zIndex: 10,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[2],
      }}
    >
      <ArrowBackIcon sx={{ transform: anchor === 'right' ? 'scaleX(-1)' : 'none' }} />
    </IconButton>

    <Box sx={{ mt: 10, direction: 'rtl',}}>
      {children}
    </Box>
  </Box>
    </Drawer>
  );
};

export default StyledDrawer;
